module.exports = __webpack_public_path__ + "static/media/logo.7cae8c63.png";